// extracted by mini-css-extract-plugin
export default {"popup":"Popup_popup__sQ1WW","popup__content":"Popup_popup__content__uwLPp"};